<template>
  <div class="pic-list">
    <div
      v-if="operationType===1"
    >
      <div class="trigger">
        <el-form>
          <el-button
            type="primary"
            @click="uploadPicVisible=true"
          >添加照片</el-button>
          <el-button
            type="primary"
            @click="handleDelete"
          >删除照片</el-button>
        </el-form>
      </div>
    </div>
    <div style="display: flex;margin-top: 5px">
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :row-data="rowData"
        :column-defs="columnDefs"
        style="width:100%;height: 400px"
        @gridReady="params=>gridOptions.columnApi=params.api"
      />
    </div>
    <upload-pic-dialog
      :warehouse-in-uuid="warehouseInUuid"
      title="添加照片"
      :visible="uploadPicVisible"
      :action="URL.warehouseIn.uploadPhotoFile"
      @onClose="handleClose"
    />
  </div>
</template>
<script>
import {
  queryBusinessDocument,
  batchDeletePhotoFile
} from '@/api/OMS/warehouseIn'
import uploadPicDialog from './uploadPicDialog'
import URL from '@/api/urlTranslator'
import { getLoading } from '@/utils/utilBaseElement'
import { getToken } from '@/utils/auth'
import { cacheName, cache } from '@/utils/cacheManager'
export default {
  name: 'PicList',
  components: { uploadPicDialog },
  props: {
    operationType: {
      type: Number,
      default: () => 1
    },
    warehouseInUuid: { type: String, default: () => '' }
  },
  data() {
    return {
      URL,
      uploadPicVisible: false,
      rowData: [],
      user: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        columnApi: null,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: '文件名',
          field: 'documentId',
          width: 150,
          cellRenderer: (params) => {
            return `<a href="${URL.common.findByFileId}/${
              params.value
            }?sessionId=${getToken()}" style="color:#46a6ff">${
              params.data.fileName
            }</a>`
          }
        },
        {
          headerName: '文件类型',
          field: 'fileType',
          width: 150
        },
        {
          headerName: '文件大小',
          field: 'fileSize',
          width: 150,
          cellRenderer: (params) => {
            return params.value + 'KB'
          }
        },
        {
          headerName: '上传者',
          field: 'createUserName',
          width: 150
        },
        {
          headerName: '上传时间',
          field: 'dateCreated',
          width: 150
        }
      ]
    }
  },
  computed: {
    storageURL() {
      return this.configMap.get('StorageURL')
    }
  },
  watch: {
    warehouseInUuid(newVal, oldVal) {
      if (!newVal) {
        this.rowData = []
      }
      if (newVal && newVal !== oldVal) {
        this.fetchList()
      }
    }
  },
  async created() {
    await cache.load(cacheName.USER, cacheName.CONFIG)
    this.user = cache.user
    this.configMap = cache.config
  },
  methods: {
    fetchList() {
      this.loading = getLoading()
      const params = {
        warehouseInUuid: this.warehouseInUuid
      }
      queryBusinessDocument(params)
        .then((res) => {
          this.rowData = res.data
          this.loading.close()
        })
        .catch(() => {
          this.loading.close()
        })
    },
    handleDelete() {
      const { columnApi } = this.gridOptions
      const selectedRows = columnApi.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.error('请选择需要删除的照片')
        return
      }
      const itemNames = selectedRows.map((item) => item.fileName)
      const h = this.$createElement
      const content = h('div', null, [
        h('span', null, '文件名：'),
        h('p', { style: 'overflow-wrap: break-word;' }, itemNames.join(',')),
        h('p', { style: 'color: red' }, '是否确定清除以上照片？')
      ])
      this.$confirm(content, '清除进仓信息', {
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        const documentUuids = selectedRows.map((item) => item.uuid)
        const params = {
          warehouseInUuid: this.warehouseInUuid,
          documentUuids
        }
        batchDeletePhotoFile(params)
          .then((res) => {
            this.$message.success('删除成功')
            this.loading.close()
            this.fetchList()
          })
          .catch(() => {
            this.loading.close()
          })
      })
    },
    handleClose() {
      this.uploadPicVisible = false
      this.fetchList()
    }
  }
}
</script>
